import { Star } from "lucide-react";

export default function Rating({ value = 0, size = 12, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "text-gold fill-gold" : "text-line"}
        />
      ))}
    </span>
  );
}
